/**
 * Authentication Provider Switcher
 * 
 * This module dynamically selects the appropriate authentication implementation
 * based on the AUTH_PROVIDER configuration setting.
 */

import { config } from "../config/config";
import constants from "../config/constants";

// Import both authentication implementations
import * as AmazonAuth from "./cognito-auth";
import * as LassoAuth from "./cognito-auth-lasso";

/**
 * Get the current authentication provider from config
 */
function getAuthProvider(): string {
  const provider = (config as any).AUTH_PROVIDER || constants.AUTH_PROVIDER_AMAZON;
  console.log('='.repeat(80));
  console.log('[AuthProvider] 🔍 AUTHENTICATION PROVIDER DETECTION');
  console.log('[AuthProvider] Config object:', config);
  console.log('[AuthProvider] AUTH_PROVIDER value from config:', (config as any).AUTH_PROVIDER);
  console.log('[AuthProvider] Default if undefined:', constants.AUTH_PROVIDER_AMAZON);
  console.log('[AuthProvider] ✓ Final provider selected:', provider);
  console.log('[AuthProvider] Available constants:');
  console.log('[AuthProvider]   - AUTH_PROVIDER_AMAZON:', constants.AUTH_PROVIDER_AMAZON);
  console.log('[AuthProvider]   - AUTH_PROVIDER_LASSO:', constants.AUTH_PROVIDER_LASSO);
  console.log('='.repeat(80));
  return provider;
}

/**
 * Get the appropriate authentication module based on configuration
 * This is called dynamically each time to ensure config is loaded
 */
function getAuthModule() {
  const provider = getAuthProvider();
  
  if (provider === constants.AUTH_PROVIDER_LASSO) {
    console.log('[AuthProvider] ✅ Loading LASSO authentication module (cognito-auth-lasso.ts)');
    return LassoAuth;
  } else {
    console.log('[AuthProvider] ✅ Loading AmazonFederate authentication module (cognito-auth.ts)');
    return AmazonAuth;
  }
}

// Export authentication functions that dynamically delegate to the appropriate provider
export function hasAccessTokens(): Promise<boolean> {
  return getAuthModule().hasAccessTokens();
}

export function initializeSession(
  onSessionExpired?: () => void,
  onSessionWillExpire?: (willExpire: boolean) => void,
  onUserProfileChange?: (user: any) => void
): Promise<void> {
  return getAuthModule().initializeSession(onSessionExpired, onSessionWillExpire, onUserProfileChange);
}

export function getAccessToken(): Promise<string> {
  return getAuthModule().getAccessToken();
}

export function redirectToLoginPage(): void {
  console.log('[AuthProvider] 🔄 redirectToLoginPage called - determining provider...');
  return getAuthModule().redirectToLoginPage();
}

export function signOut(): Promise<void> {
  return getAuthModule().signOut();
}

export function getUserInfo(): Promise<any> {
  console.log('[AuthProvider] 📞 getUserInfo called - determining provider...');
  return getAuthModule().getUserInfo();
}

// Export username with dynamic getter
export let username = "";

Object.defineProperty(exports, 'username', {
  get: () => {
    const module = getAuthModule();
    return module.username;
  },
  enumerable: true,
  configurable: true
});
